import React from 'react';
import { CheckOne, Close, Fire, Time, Shield } from '@icon-park/react';

/**
 * BenefitTabs - 用户权益展示组件
 */
export function BenefitTabs({ benefitTab, resolvedBenefitType, onTabChange }) {
  const benefits = {
    summary: [
      {
        icon: <Fire theme="filled" size={20} fill="#FF6B35" />,
        text: '专业数字标签生成',
        badge: '全部可用'
      },
      {
        icon: <Shield theme="filled" size={20} fill="#2563EB" />,
        text: '标签合规性检测',
        badge: '全部可用'
      },
      {
        icon: <Time theme="filled" size={20} fill="#06B6D4" />,
        text: '7×24小时技术支持',
        badge: '企业版'
      }
    ],
    enterprise: [
      {
        icon: <CheckOne theme="filled" size={20} fill="#06B6D4" />,
        text: '无限标签生成',
        available: true
      },
      {
        icon: <CheckOne theme="filled" size={20} fill="#06B6D4" />,
        text: '支持账号转移',
        available: true
      },
      {
        icon: <CheckOne theme="filled" size={20} fill="#06B6D4" />,
        text: '内容永久保留',
        available: true
      },
      {
        icon: <CheckOne theme="filled" size={20} fill="#06B6D4" />,
        text: 'API接口调用',
        available: true
      },
      {
        icon: <CheckOne theme="filled" size={20} fill="#06B6D4" />,
        text: '专属客服支持',
        available: true
      }
    ],
    individual: [
      {
        icon: <CheckOne theme="filled" size={20} fill="#06B6D4" />,
        text: '基础标签生成',
        available: true
      },
      {
        icon: <Close theme="filled" size={20} fill="#94a3b8" />,
        text: '账号转移',
        available: false
      },
      {
        icon: <Time theme="outline" size={20} fill="#64748b" strokeWidth={3} />,
        text: '内容保留1年',
        available: true
      },
      {
        icon: <Close theme="filled" size={20} fill="#94a3b8" />,
        text: 'API接口',
        available: false
      },
      {
      icon: <CheckOne theme="filled" size={20} fill="#06B6D4" />,
        text: '社区支持',
        available: true
      }
    ]
  };

  const currentBenefits = benefits[benefitTab] || benefits.summary;

  return (
    <div className="benefits-card">
      <h3 className="benefits-title">会员权益</h3>
      <p className="benefits-subtitle">选择适合您的用户类型</p>
      
      <div className="type-tabs">
        <button 
          className={`type-tab ${benefitTab === 'enterprise' ? 'active' : ''}`}
          onClick={() => onTabChange('enterprise')}
        >
          🏢 企业版
        </button>
        <button 
          className={`type-tab ${benefitTab === 'individual' ? 'active' : ''}`}
          onClick={() => onTabChange('individual')}
        >
          👤 个人版
        </button>
      </div>
      
      <div className="benefits-list">
        {currentBenefits.map((benefit, index) => (
          <div key={index} className={`benefit-item ${benefit.available === false ? 'unavailable' : ''}`}>
            <div className="benefit-icon">
              {benefit.icon}
            </div>
            <div className="benefit-text">
              {benefit.text}
            </div>
            {benefit.badge && (
              <span className="benefit-badge">{benefit.badge}</span>
            )}
          </div>
        ))}
      </div>

      {benefitTab === 'enterprise' && (
        <div className="enterprise-note">
          <strong>🎉 企业版特权</strong>
          <p>享受全功能访问权限和优先技术支持</p>
        </div>
      )}
    </div>
  );
}
